const getNewOcc = async (formState) => {
    const newOccupancy =
        ((formState.currentRate - formState.costOfOccupiedRoom) /
            (formState.proposedRate - formState.costOfOccupiedRoom)) *
        formState.forecastedOcc;

    return Math.round(newOccupancy).toString();
};

const checkAllInputsFilled = (formState) => {
    if (
        formState.totalRooms &&
        formState.currentRate &&
        formState.proposedRate &&
        formState.costOfOccupiedRoom &&
        formState.forecastedOcc
    ) {
        return true;
    }
    return false;
};

const getCSVData = (formData) => {
    const rows = [
        [
            'Input',
            'Total rooms',
            'Current rate',
            'Proposed rate',
            'Cost of occupied room',
            'Forecasted Occupancy',
            'Forecasted Actual',
            'Occupancy required',
            'Additional occupancy',
            'Rooms required',
            'Actual rooms',
        ],
        [
            'Value',
            formData.totalRooms,
            formData.currentRate,
            formData.proposedRate,
            formData.costOfOccupiedRoom,
            formData.forecastedOcc,
            formData.forecastedActual,
            formData.newOccupancy,
            formData.addOccupancy,
            formData.newRooms,
            formData.actualRooms,
        ],
    ];

    return rows;
};

export { getNewOcc, checkAllInputsFilled, getCSVData };
